import { OrderReturnItem } from "./order-return-response";
import getStatusText from "./status";

const row = ({
    returnNumber,
    status,
    createdAt,
    createdBy,
    positions,
    detailLink,
}: OrderReturnItem): string => {
    const statusText = getStatusText(status);
    return `
        <tr>
            <td>${returnNumber}</td>
            <td>${statusText}</td>
            <td>${createdAt}</td>
            <td>${createdBy}</td>
            <td>${positions}</td>
            <td><ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button></td>
        </tr>
    `;
};

export default row;
